class Header {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.parentItemEl = this.root.querySelectorAll(
            '.menu-item-has-children > a'
        );
        this.burgerToggleEl = this.root.querySelector('[header-burger-toggle]');
        this.headerMenuEl = this.root.querySelector('[header-menu]');
        this.headerSocialStickyEl = document.querySelector(
            '[header-social-sticky]'
        );

        console.log(this.headerSocialStickyEl);

        return true;
    }

    init() {
        this.setParentItems();
        this.setOutsideClickHandler();
        this.setBurgerEl();
    }

    setParentItems() {
        if (!this.parentItemEl) return;

        this.onParent = this.onParentClick.bind(this);
        this.parentItemEl.forEach(item => {
            console.log(item);

            item.addEventListener('click', this.onParent);
        });
    }

    setBurgerEl() {
        if (!this.burgerToggleEl) return;

        this.onBurger = this.onBurgerClick.bind(this);
        this.burgerToggleEl.addEventListener('click', this.onBurger);
    }

    onParentClick(event) {
        event.preventDefault();

        const { currentTarget } = event;

        const parentEl = currentTarget.closest('.menu-item-has-children');

        const submenu = parentEl.querySelector('.sub-menu');
        const iconEl = currentTarget.querySelector('.icon');

        if (!submenu) return;
        this.closeAllSubMenus(submenu);

        parentEl.classList.toggle('-active');
        submenu.classList.toggle('-active');
        iconEl.classList.toggle('-rotate-180');
    }

    onBurgerClick(event) {
        if (!this.headerMenuEl) return;
        const { currentTarget } = event;

        const iconEl = this.burgerToggleEl.querySelector('.icon');

        currentTarget.classList.toggle('bg-transparent!');
        this.headerMenuEl.classList.toggle('-active');        

        if (iconEl) {
            iconEl.classList.toggle('icon-menu-burger');
            iconEl.classList.toggle('icon-close');
        }

        if (this.headerSocialStickyEl)
            this.headerSocialStickyEl.classList.toggle('hidden!');
    }

    setOutsideClickHandler() {
        document.addEventListener('click', event => {
            if (!this.root.contains(event.target)) {
                this.closeAllSubMenus();
            }
        });
    }

    closeAllSubMenus(excludeEl) {
        this.root.querySelectorAll('.sub-menu.-active').forEach(submenu => {
            const parentEl = submenu.closest('.menu-item');

            if (excludeEl) {
                if (!submenu.isEqualNode(excludeEl)) {
                    if (parentEl) {
                        const iconEl = parentEl.querySelector(
                            '[header-menu-parent-icon]'
                        );
                        parentEl.classList.remove('-active');
                        if (iconEl) iconEl.classList.toggle('-rotate-180');
                    }

                    submenu.classList.remove('-active');
                }
            } else {
                if (parentEl) {
                    const iconEl = parentEl.querySelector(
                        '[header-menu-parent-icon]'
                    );
                    parentEl.classList.remove('-active');
                    if (iconEl) iconEl.classList.toggle('-rotate-180');
                }

                submenu.classList.remove('-active');
            }
        });
    }
}

export default initHeader => {
    const headerEl = document.querySelector('[header]');
    if (!headerEl) return;

    new Header(headerEl);
};
